import httpClient from "../config/httpClient";

export async function updateReadNotification(
  notificationId: string
): Promise<void> {
  await httpClient.peopleBff.put(
    `/user/update_read_notification/?notification_id=${notificationId}`
  );
}
